<template>
  <div>
    待开发
  </div>
</template>

<script>
export default {
  name: "referee",
};
</script>

